import { Pipe, PipeTransform } from '@angular/core';
import { Company } from '../interfaces/company';
import { Utils } from '../resources/utils';

@Pipe({
    name: 'filterCompanies',
    pure: false

})
export class filterCompaniesPipe implements PipeTransform {

    constructor(
        private utils: Utils
    ) { }

    transform(data: Company[], filter: { nitOrName: string, state: boolean }): Company[] {
        const resultCompanies = [];
        for (const company of data) {
            const companyName = company && company.name ? company.name.toLowerCase() : '';
            const companyId = company && company.companyId ? company.companyId.toLowerCase() : '';
            const filterName = filter && filter.nitOrName ? filter.nitOrName.toLowerCase() : '';
            const filterState = filter && this.utils.isDefined(filter.state) ? filter.state : null;

            const fillsNameFilter = filterName ? companyName.includes(filterName) || companyId.startsWith(filterName) : true;
            const fillsStateFilter = this.utils.isDefined(filterState) ? filterState === this.utils.companyIsActive(company) : true;
            if (fillsNameFilter && fillsStateFilter)
                resultCompanies.push(company);
        };
        return resultCompanies;
    }
}

